import React from 'react';

const MediaManagerAppContext = React.createContext({
  onClose: undefined,
  onSelectFiles: undefined,
  isInIframe: false,
});

export default MediaManagerAppContext;
